import {AppLocale} from '@config/locales';
import {useLocale as useIntlLocale} from 'next-intl';

export const useLocale = () => useIntlLocale() as AppLocale;
